import { either, path } from 'ramda';

export const getIsVisible = path(['passcode', 'visibleFor']);
export const getIsPassedByIdOrRoute = (state, idOrRoute) => either(
  path(['passcode', 'byBarberId', idOrRoute]),
  path(['passcode', 'byBarberRoute', idOrRoute]),
)(state);



// WEBPACK FOOTER //
// ./src/app/passcode/selectors.js